import React from "react";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import ButtonUberComponent from "./button-uber.component";
import ButtonDeliverooComponent from "./button-deliveroo.component";

export default function ButtonComponent(props) {
    const {t} = useTranslation();
    const uber = props.uber ?? null;
    const deliveroo = props.deliveroo ?? null;

    return (
        <div
            className={`min-w-full flex ${props.type !== "home" ? 'flex-col' : props.isMobile ? 'flex-col bg-backgroundSecondary px-8 py-4' : 'bg-backgroundSecondary px-8 py-4'} items-center justify-center text-center gap-4 ${props.width ?? ""} ${props.color ?? ""}`}
        >
            <div
                className={`flex ${props.type !== "home" ? 'flex-col' : props.isMobile ? 'flex-col' : 'flex-row'} items-center justify-center gap-4`}>
                {props.data.content.map((content, i) => {
                    return (
                        <Link key={i} to={content.to}
                              className={`font-bold w-fit text-2xl ${props.type === "home" ? "tr-f text-black px-1 " : "border-y border-y-white"}`}>
                            {t(`${content.text}`)}
                        </Link>
                    );
                })}
            </div>

            <div className="flex gap-4 items-center justify-center">
                {uber && <ButtonUberComponent/>}
                {deliveroo && <ButtonDeliverooComponent/>}
            </div>
        </div>
    );
}
